import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetProductTypesSlice = createSlice({
    name: "getProductTypes",
    initialState,
    reducers: {
        getProductTypesRequest(state) {
            state.loading = true;
        },
        getProductTypesRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getProductTypesRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        clearProductTypesResponse(state) {
            state.response = undefined;
            state.error = undefined;
            state.loading = false;
        }
    },
});

export const {
    getProductTypesRequest,
    getProductTypesRequestSuccess,
    getProductTypesRequestError,
    clearProductTypesResponse
} = GetProductTypesSlice.actions;

export default GetProductTypesSlice.reducer;
